import { Select, SelectProps } from 'antd'
import { useEffect, useState } from 'react'
import { apiFilterOutlets } from '../../api'
import defaultParams from '../../assets/constants/default_params'
import { filterOptionByLabel } from '../../utils/filter-utils'
import { IOutlet } from '../../models/outlet.modal'

let cachedOptions: { label: string, value: string }[] | null = null
let inFlight: Promise<{ label: string, value: string }[]> | null = null

const loadOutlets = async (): Promise<{ label: string, value: string }[]> => {
    if (cachedOptions) return cachedOptions
    if (inFlight) return inFlight
    inFlight = apiFilterOutlets({ limit: defaultParams.MAX_LIMIT, orderBy: '"name" asc' }).then((resp: any) => {
        const outlets: IOutlet[] = resp?.data?.data ?? []
        cachedOptions = outlets.map(o => ({
            label: o.name || o.code || o.id,
            value: o.id,
        }))
        return cachedOptions
    }).finally(() => {
        inFlight = null
    })
    return inFlight
}

type Props = Omit<SelectProps, 'options' | 'filterOption'> & {
    multiple?: boolean
}

export default function OutletSelect({ multiple, ...rest }: Props) {
    const [options, setOptions] = useState<{ label: string, value: string }[]>(cachedOptions ?? [])

    useEffect(() => {
        let mounted = true
        loadOutlets().then(opts => {
            if (mounted) setOptions(opts)
        })
        return () => { mounted = false }
    }, [])

    return (
        <Select
            {...rest}
            mode={multiple ? 'multiple' : undefined}
            showSearch
            allowClear
            options={options}
            filterOption={filterOptionByLabel}
            style={{ minWidth: 240, ...(rest.style ?? {}) }}
        />
    )
}
